<div fxFlex="100">
  <div fxLayout="column" fxLayoutAlign="center stretch">
    <div class="teranet-padding" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-between start">
      <Teranet-PageTitle [PageTitle]="pageTitle"></Teranet-PageTitle>
      <div class="icon-button" fxLayoutAlign="end">
        <button mat-button type="button" (click)="goToClient()">
          <div class="btnicon">
            <fa-icon icon="arrow-left" id="goToClient" class="fa-lg" matTooltipPosition="above"></fa-icon>
          </div>
          <div class="btntext">Return To Client List</div>
        </button>
      </div>
    </div>
    <div fxLayout="row wrap">
      <div class="teranet-padding" fxFlex="100">
        <mat-card>
          <mat-horizontal-stepper [linear]="isLinear"
                                  #stepper
                                  (selectionChange)="selectionChange($event)">
            <ng-template matStepperIcon="edit">
              <mat-icon>edit</mat-icon>
            </ng-template>
            <ng-template matStepperIcon="update">
              <mat-icon>edit</mat-icon>
            </ng-template>

            <mat-step [completed]="clientInfoId >= 0"
                      #stepOne
                      state="update"
                      label="Client Information">
              <ng-template matStepLabel>
                <span>Client Information</span>
              </ng-template>
              <ng-container *ngIf="stepper.selected == stepOne">
                <Teranet-ClientInfo [ClientInfoId]="ClientInfoId"
                                    [Readonly]="Readonly"
                                    (update)="ClientInfoIdChange($event)"></Teranet-ClientInfo>
              </ng-container>
            </mat-step>

            <mat-step #stepTwo
                      state="update"
                      label="Files">
              <ng-template matStepLabel>
                <span>Client Files Information</span>
              </ng-template>
              <ng-container *ngIf="stepper.selected == stepTwo">
                <app-client-file-info-parent [ClientInfoId]="ClientInfoId"
                                             [Readonly]="Readonly"></app-client-file-info-parent>
              </ng-container>
            </mat-step>
            <mat-step #stepThree
                      state="update"
                      label="Schedule">
              <ng-template matStepLabel>
                <span>File Schedule</span>
              </ng-template>
              <ng-container *ngIf="stepper.selected == stepThree">
                <Teranet-Clientfileschedules [ClientInfoId]="ClientInfoId"
                                             [Readonly]="Readonly"></Teranet-Clientfileschedules>
              </ng-container>
            </mat-step>


          </mat-horizontal-stepper>
        </mat-card>
      </div>
    </div>
  </div>
</div>
